module.exports = __webpack_public_path__ + "img/ANTENNA 3 LIME.5da235e.svg";